export function getEtatVibratoireInfo(motor) {
  // Fonction helper pour normaliser les valeurs
  const normalizeDefaut = (val) => {
    if (typeof val === 'string') {
      const lower = val.toLowerCase();
      if (lower === 'rouge') return 'rouge';
      if (lower === 'jaune') return 'jaune';
      if (lower === 'vert') return 'vert';
    }
    return 'null';
  };

  // Fonction pour déterminer le niveau de gravité (3=rouge, 2=jaune, 1=vert/null)
  const getSeverity = (defaut) => {
    if (defaut === "rouge") return 3;
    if (defaut === "jaune") return 2;
    return 1;
  };

  // Analyser tous les typeDefaut (dérive vibratoire)
  const typeDefauts = [
    motor?.typeDefautX1 || "null",
    motor?.typeDefautY1 || "null", 
    motor?.typeDefautZ1 || "null"
  ].map(normalizeDefaut);

  let typeDefautDerive = "null";
  if (typeDefauts.includes("rouge")) {
    typeDefautDerive = "rouge";
  } else if (typeDefauts.includes("jaune")) {
    typeDefautDerive = "jaune";
  } else if (typeDefauts.includes("vert")) {
    typeDefautDerive = "vert";
  }

  // Analyser tous les typeDefautVitesse (état vibratoire)
  const typeDefautsVitesse = [
    motor?.typeDefautVitesseX1 || "null",
    motor?.typeDefautVitesseX2 || "null",
    motor?.typeDefautVitesseY1 || "null",
    motor?.typeDefautVitesseY2 || "null",
    motor?.typeDefautVitesseZ1 || "null",
    motor?.typeDefautVitesseZ2 || "null"
  ].map(normalizeDefaut);

  let typeDefautEtat = "null";
  if (typeDefautsVitesse.includes("rouge")) {
    typeDefautEtat = "rouge";
  } else if (typeDefautsVitesse.includes("jaune")) {
    typeDefautEtat = "jaune";
  } else if (typeDefautsVitesse.includes("vert")) {
    typeDefautEtat = "vert";
  }

  // Déterminer l'erreur principale (la plus grave)
  const severityDerive = getSeverity(typeDefautDerive);
  const severityEtat = getSeverity(typeDefautEtat);
  
  let erreurPrincipale, erreurSecondaire;
  if (severityDerive >= severityEtat) {
    erreurPrincipale = { type: "derive", niveau: typeDefautDerive };
    erreurSecondaire = severityEtat > 1 ? { type: "etat", niveau: typeDefautEtat } : null;
  } else {
    erreurPrincipale = { type: "etat", niveau: typeDefautEtat };
    erreurSecondaire = severityDerive > 1 ? { type: "derive", niveau: typeDefautDerive } : null;
  }

  // Vérifier s'il y a une erreur de courant anormal
  const erreurs = motor?.etatVibratoire || [];
  const erreurCourantAnormal = erreurs.includes("Possibles défauts du moteur dû à la consommation de courant");

  // Générer les messages
  const getMessagePart = (type, niveau) => {
    const prefix = type === "derive" ? "DÉRIVE VIBRATOIRE" : "ÉTAT VIBRATOIRE";
    if (niveau === "rouge") return `${prefix} IMPORTANT${type === "derive" ? "E" : ""}`;
    if (niveau === "jaune") return `${prefix} À SURVEILLER`;
    return `${prefix} NORMAL${type === "derive" ? "E" : ""}`;
  };

  let messagePrincipal = getMessagePart(erreurPrincipale.type, erreurPrincipale.niveau);
  let messageSecondaire = erreurSecondaire ? getMessagePart(erreurSecondaire.type, erreurSecondaire.niveau) : null;

  // Si les deux sont normaux, afficher un message combiné simplifié
  if (erreurPrincipale.niveau !== "rouge" && erreurPrincipale.niveau !== "jaune" && 
      (!erreurSecondaire || (erreurSecondaire.niveau !== "rouge" && erreurSecondaire.niveau !== "jaune"))) {
    messagePrincipal = "ÉTAT NORMAL";
    messageSecondaire = null;
  }

  // Déterminer la couleur selon l'erreur principale
  let bgColor = "";
  if (erreurPrincipale.niveau === "rouge") {
    bgColor = "#ff7d7d";
  } else if (erreurPrincipale.niveau === "jaune") {
    bgColor = "#f3f907";
  } else {
    bgColor = "#86c80f";
  }

  // Si erreur courant anormal et que ce n'était pas rouge, passer en orange
  if (erreurCourantAnormal && erreurPrincipale.niveau !== "rouge") {
    bgColor = "#ef9d3c";
  }

  return { 
    messagePrincipal, 
    messageSecondaire, 
    bgColor, 
    erreurCourantAnormal 
  };
}

export default function EtatMachineCell({ motor }) {
  const { messagePrincipal, messageSecondaire, bgColor, erreurCourantAnormal } = getEtatVibratoireInfo(motor);

  return (
    <div
      className="rounded-md text-center text-sm font-bold p-2"
      style={{ backgroundColor: bgColor, color: "#333" }}
    >
      <div>{messagePrincipal}</div>
      {messageSecondaire && (
        <div className="text-xs font-semibold mt-1 opacity-90">
          {messageSecondaire}
        </div>
      )}
      {erreurCourantAnormal && (
        <p className="text-sm text-red-700 font-medium mt-1">⚠ Courant anormal</p>
      )}
    </div>
  );
}